import React from 'react';

const MIN_LENGTH = 8;

const criteria = [
  { test: (p) => p.length >= MIN_LENGTH, label: 'At least 8 characters' },
  { test: (p) => p.length >= 12,         label: '12+ characters (stronger)' },
  { test: (p) => /[a-z]/.test(p) && /[A-Z]/.test(p), label: 'Upper & lowercase letters' },
  { test: (p) => /\d/.test(p),           label: 'A number' },
  { test: (p) => /[^a-zA-Z0-9]/.test(p), label: 'A special character (!@#$...)' },
];

function getStrength(password) {
  if (!password) return { score: 0, label: '', color: '' };

  const passed = criteria.filter(c => c.test(password)).length;

  if (password.length < MIN_LENGTH) {
    return { score: 1, label: 'Too short', color: '#ef4444' };
  }
  if (passed <= 2) return { score: 2, label: 'Weak', color: '#ef4444' };
  if (passed === 3) return { score: 3, label: 'Fair', color: '#f59e0b' };
  if (passed === 4) return { score: 4, label: 'Good', color: '#22c55e' };
  return { score: 5, label: 'Strong', color: '#16a34a' };
}

const PasswordStrengthMeter = ({ password }) => {
  if (!password) return null;

  const { score, label, color } = getStrength(password);
  const pct = (score / 5) * 100;

  return (
    <div className="space-y-1.5">
      {/* Bar */}
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>

      {/* Label */}
      <div className="flex justify-between text-xs">
        <span style={{ color }} className="font-medium">{label}</span>
      </div>

      {/* Criteria checklist */}
      <ul className="grid grid-cols-1 gap-0.5 text-xs text-gray-500">
        {criteria.map(({ test, label: cLabel }) => {
          const met = test(password);
          return (
            <li key={cLabel} className="flex items-center gap-1.5">
              <span className={met ? 'text-green-500' : 'text-gray-300'}>
                {met ? '\u2713' : '\u2022'}
              </span>
              <span className={met ? 'text-gray-700' : ''}>{cLabel}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { MIN_LENGTH };
export default PasswordStrengthMeter;
